

















import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { VFields } from '@/models/v-fields';
import { Base } from '@/components/common/base';
import { storeService } from '@/shared';
import { AuthorizeNetAccountAddOrUpdateViewModel } from '@/models/payment/authorizeNetAccount';

@Component({
    props: ['methodName', 'progress'],
    computed: {
        methodtoCall: {
            get() {
                return this.$props.methodName;
            },
        },
    },
})
export default class AddAuthorizeNetAccountPage extends Base {
    public vm: AuthorizeNetAccountAddOrUpdateViewModel = new AuthorizeNetAccountAddOrUpdateViewModel();
    public form: any = {};
    public formFields: Array<VFields<any>> = [];
    public disableSubmitButton: boolean = false;
    public tenantId: number = 0;
    public enterpriseId: number = 0;
    public authorizeNetEnvironment: string = "";
    public created(): void {
        this.setFields();
    }

    public beforeDestroy() {
        const buttons = [];
        this.$emit('updateToolBar', buttons);
    }
    public callMethod(methodName): void {
        if (methodName === 'backToStoreEdit') {
            this.$router
                .push({
                    name: 'admin.stores.edit',
                    params: { id: this.vm.storeId.toString(), tab: 'AuthorizeNetAccount' },
                })
                .catch((ex) => {
                    console.log(ex);
                });
        } else if (methodName === 'submit') {
            if (!this.form.$valid) {
                this.showAlert(false, this.$t('cenposAccounts.alertFormInvalid'));
                this.resetMethodName(methodName);
                return;
            }
            this.submitAuthorizeNetAccount();
        } else {
            console.log(methodName);
        }
        this.resetMethodName(methodName);
    }
    public resetMethodName(methodName): void {
        if (methodName !== '') {
            this.$emit('resetMethodName', methodName);
        }
    }
    public updateToolBar(): void {
        const buttons: any = [];
        buttons.push({
            id: '0',
            type: 'button',
            title: this.$parent.$t('stores.btnBackToStoreTitle'),
            disabled: false,
            visible: true,
            class: 'btn',
            label: this.$parent.$t('stores.btnBack'),
            click: 'backToStoreEdit',
            icon: 'fas fa-arrow-left',
        });
        this.$emit('updateToolBar', buttons);
    }
    public mounted() {
        // Toolbar
        this.updateToolBar();
        this.$watch('methodtoCall', (newVal, oldVal) => {
            if (newVal) {
                this.callMethod(newVal);
            }
        });
        this.setFields();
        this.vm.storeId = Number(this.$route.params.storeId);
        this.getAuthorizeNetAccountDetails();
    }

    public setFields(): void {
        this.formFields = [
            {
                key: 'environment',
                required: true,
                type: 'v-alynk-select',
                templateOptions: {
                    disabled: false,
                    required: true,
                    label: 'Environment',
                    items: [
                        'Production',
                        'Sandbox',
                    ],
                    loading: false,
                    rules: [
                        v => this.required('Environment', v)
                    ], events: {
                        onChange: (items, value) => {
                            this.authorizeNetEnvironment = value;
                            this.getAuthorizeNetAccountDetails();
                        },
                    },
                },
            },
            {
                key: 'apiLoginId',
                type: 'v-alynk-text-field',
                required: true,
                templateOptions: {
                    counter: 50,
                    label: 'Api Login Id',
                    required: true,
                    disabled: false,
                    rules: [
                        v => this.required('Api Login Id', v)
                    ]
                },
            },
            {
                key: 'transactionKey',
                type: 'v-alynk-text-field',
                required: true,
                templateOptions: {
                    counter: 50,
                    label: 'Transaction Key',
                    required: true,
                    disabled: false,
                    rules: [
                        v => this.required('Transaction Key', v)
                    ]
                },
            },
            {
                key: 'hostedFieldCdnUri',
                type: 'v-alynk-text-field',
                required: true,
                templateOptions: {
                    counter: 50,
                    label: 'Hosted Field Cdn Uri',
                    required: true,
                    disabled: false,
                    rules: [
                        v => this.required('Hosted Field Cdn Uri', v)
                    ]
                },
            }
        ];
    }

    public validateAuthorizeNetAccount(): Vue & { validate: () => boolean } {
        return this.$refs.authorizeNetAccountForm as Vue & { validate: () => boolean };
    }

    public async submitAuthorizeNetAccount(): Promise<void> {
        if (this.validateAuthorizeNetAccount().validate()) {
            try {
                this.disableSubmitButton = true;
                this.$emit('update:progress', this.disableSubmitButton);
                await storeService.updateAuthorizeNetAccounts(
                    this.vm.storeId,
                    this.vm.account
                );
                this.showAlert(true, 'Authorize Net Account Successfully saved');
                this.$router.push({
                    name: 'admin.stores.edit',
                    params: {
                        tenantId: this.tenantId.toString(),
                        enterpriseId: this.enterpriseId.toString(),
                        storeId: this.vm.storeId.toString(),
                        tab: 'AuthorizeNetAccount'
                    },
                });
            } finally {
                this.disableSubmitButton = false;
                this.$emit('update:progress', this.disableSubmitButton);
            }
        }
    }

    public async getAuthorizeNetAccountDetails(): Promise<void> {
        try {
            this.disableSubmitButton = true;
            this.$emit('update:progress', this.disableSubmitButton);
            this.formlyShowSkeleton(this.formFields);
            const response = await storeService.getAuthorizeNetAccountDetails(
                this.vm.storeId,
                this.authorizeNetEnvironment
            );
            if (response) {
                this.vm.account = response;
            }
        } finally {
            this.authorizeNetEnvironment = "";
            this.formlyHideSkeleton(this.formFields);
            this.disableSubmitButton = false;
            this.$emit('update:progress', this.disableSubmitButton);
        }
    }
}
